/* Nordbjærg's: today's opening hours, computed in the browser so cached pages never show yesterday's.
   Markup: <span data-nb-hours="man=10:00-17:30\ntir=…" data-nb-hours-open="Butikken har åbent i dag {hours}"
                 data-nb-hours-closed="Butikken har lukket i dag" hidden></span>
   The element stays hidden when JS is off, when the text for today is empty, or when today has no line
   and no closed text is given. A hidden ancestor marked data-nb-hours-wrapper is shown along with it. */
(function () {
  var DAYS = ['søn', 'man', 'tir', 'ons', 'tor', 'fre', 'lør'];

  function todaysLine(spec) {
    var today = DAYS[new Date().getDay()];
    var lines = String(spec || '').split(/\r?\n/);
    for (var i = 0; i < lines.length; i++) {
      var parts = lines[i].split('=');
      if (parts.length < 2) continue;
      if (parts[0].trim().toLowerCase() === today) return parts.slice(1).join('=').trim();
    }
    return '';
  }

  function render(el) {
    var hours = todaysLine(el.getAttribute('data-nb-hours')).replace(/\s*-\s*/, '–');
    var text = '';
    if (hours) {
      text = (el.getAttribute('data-nb-hours-open') || '{hours}').replace('{hours}', hours);
    } else {
      text = el.getAttribute('data-nb-hours-closed') || '';
    }
    if (!text) return;
    el.textContent = text;
    el.hidden = false;
    var wrapper = el.closest('[data-nb-hours-wrapper]');
    if (wrapper) wrapper.hidden = false;
  }

  function init(root) {
    var els = (root || document).querySelectorAll('[data-nb-hours]');
    for (var i = 0; i < els.length; i++) render(els[i]);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(); });
  } else {
    init();
  }
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
